import { useMemo } from 'react';

import {
	ActionKey,
	useMonitoringTranslations,
	useRoutesPlannerManualValidation
} from '@bringg-frontend/monitoring-shared';
import { DropdownMenuItem } from '@bringg/react-components';
import { Task } from '@bringg/types';

import useMonitoringStore from './use-monitoring-store';
import { useSelectedStore } from './use-selected-store';

const useBulkActionsList = (selectedTasksForActions: Task[]) => {
	const { toggleModalVisibility } = useMonitoringStore();

	const {
		store: { selectMany }
	} = useSelectedStore();

	const { routesPlanner } = useMonitoringTranslations();

	const { getRoutesPlannerManuallyOpenError, addRouteUnselectedTasks } = useRoutesPlannerManualValidation(selectMany);

	const routesPlannerManuallyOpenError = useMemo(() => {
		return getRoutesPlannerManuallyOpenError(selectedTasksForActions);
	}, [getRoutesPlannerManuallyOpenError, selectedTasksForActions]);

	const onOpenRoutesPlanner = async () => {
		await addRouteUnselectedTasks(selectedTasksForActions);
		toggleModalVisibility(ActionKey.routesPlanner, true);
	};

	const actions: DropdownMenuItem[] = [
		{
			key: 'routesPlanner',
			label: routesPlanner,
			disabled: !!routesPlannerManuallyOpenError,
			tooltip: routesPlannerManuallyOpenError,
			onClick: onOpenRoutesPlanner
		}
	];

	return actions;
};

export default useBulkActionsList;
